export default "__VITE_ASSET__CI$KQqZx__"